import { EVENT_CLICK } from '../../../hooks/useTracking/events/eventTypes.js';
export const action = payload => {
  return {
    type: EVENT_CLICK,
    payload
  };
};
export const handler = action => {
  return {
    non_interaction: false,
    event: 'cia',
    ...action.payload,
    event_action: `${action.payload.event_action}_click`
  };
};